import { observer } from '~/modules';
import CreditSimulationConfirmation from './CreditSimulationConfirmation';
const CreditSimulationConfirmationContainer = () => {
  return <CreditSimulationConfirmation />;
};

export default observer(CreditSimulationConfirmationContainer);
